"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Type = exports.Status = exports.LGPD = void 0;

var _Exception = require("../../Exceptions/Exception");

var _ExceptionCode = require("../../Exceptions/ExceptionCode");

var _Tools = require("../../Tools");

var _CPF = _interopRequireDefault(require("../../Tools/CPF"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const Type = {
  GESTAO: "G",
  //Usuário do ambiente Gestão (G)
  MARKETPLACE: "M",
  //Clientes cadastrado pelo Marketplace (M)
  FRONT: "F",
  //Clientes cadastrado pelo Aplicativo do Restaurante (F)
  LOCAL: "L",
  //Cliente cadastrado pelo Gestão (L)
  MONITOR: "S" //Cliente cadastrado pelo Monitor (S)

};
exports.Type = Type;
const Status = {
  VERIFIED: "VERIFIED",
  UNVERIFIED: "UNVERIFIED",
  DISABLED: "DISABLED"
};
exports.Status = Status;
const LGPD = {
  SMS: 1,
  EMAIL: 2
};
exports.LGPD = LGPD;

function looksLikeMail(str) {
  var lastAtPos = str.lastIndexOf("@");
  var lastDotPos = str.lastIndexOf(".");
  return lastAtPos < lastDotPos && lastAtPos > 0 && str.indexOf("@@") == -1 && lastDotPos > 2 && str.length - lastDotPos > 2;
}

function isMobilePhoneBR(phoneNumber) {
  return /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[2-9]{1}\d{3}\-?\d{4}))$/.test(phoneNumber);
}

class User {
  constructor(arr_properties, full_json = false) {
    _defineProperty(this, "full_json", false);

    _defineProperty(this, "id", null);

    _defineProperty(this, "type", null);

    _defineProperty(this, "username", null);

    _defineProperty(this, "email", null);

    _defineProperty(this, "password", null);

    _defineProperty(this, "lgpd", null);

    _defineProperty(this, "fb_id", null);

    _defineProperty(this, "google_id", null);

    _defineProperty(this, "gender", null);

    _defineProperty(this, "cpf", null);

    _defineProperty(this, "name", null);

    _defineProperty(this, "group", null);

    _defineProperty(this, "phone", null);

    _defineProperty(this, "birthdate", null);

    _defineProperty(this, "retrieve_password", null);

    _defineProperty(this, "retrieve_password_until", null);

    this.full_json = full_json;
    this.setProps(arr_properties);
  }

  setProps(obj) {
    Object.keys(obj).forEach(key => {
      this[key] = obj[key];
    });
  }

  setFullJson(full_json = false) {
    this.full_json = full_json;
  }

  validate(arr = null) {
    var _arr;

    arr = (_arr = arr) !== null && _arr !== void 0 ? _arr : ["username", "email", "password", "name", "phone", "birthdate", "cpf", "gender"];
    arr.forEach(item => {
      switch (item) {
        case "username":
          // o termo "nome de usuário" utilizado abaixo é provisório
          if (this.username == null || this.username == "" || this.username.length < 3 || this.username.length > 20) {
            throw new _Exception.Exception(null, "O nome de usuário deve conter entre 3 e 20 caracteres.");
          }

          const letters = this.username.match(/[a-z]/g);

          if (!letters || letters.length < 3) {
            throw new _Exception.Exception(null, "O nome de usuário deve conter ao menos 3 letras.");
          }

          if (!this.username.match(/^[0-9a-z].+[0-9a-z]$/i)) {
            throw new _Exception.Exception(null, "O nome de usuário deve começar e terminar com letras ou números.");
          }

          if (!this.username.match(/^[0-9a-z\-_\.]+$/i)) {
            throw new _Exception.Exception(null, "O nome de usuário deve conter somente letras, números, ponto(.), underline(_) e hífen(-).");
          }

          this.username = this.username.toLowerCase();
          break;

        case "email":
          if (!looksLikeMail(this.email)) {
            throw new _Exception.Exception(_ExceptionCode.ExceptionCode.ACCOUNT_INVALID_EMAIL_FORMAT);
          }

          this.email = String(this.email).toLowerCase().trim();
          break;

        case "password":
          if (this.password == null || this.password == "" || this.password.length < 8) {
            throw new _Exception.Exception(_ExceptionCode.ExceptionCode.ACCOUNT_PASSWORD_MINIMUM);
          }

          break;

        case "name":
          if (this.name == "" || this.name.length < 3 || this.name.length > 255) {
            throw new _Exception.Exception(_ExceptionCode.ExceptionCode.ACCOUNT_NAME_REQUIRED);
          }

          this.name = this.name;
          break;

        case "phone":
          if (!isMobilePhoneBR(this.phone)) {
            throw new _Exception.Exception(_ExceptionCode.ExceptionCode.ACCOUNT_INVALID_PHONE);
          }

          this.phone = this.phone;
          break;

        case "birthdate":
          let newDate = _Tools.DateTime.fromFormat("YYYY-mm-dd", this.birthdate);

          if (this.birthdate && this.birthdate != _Tools.DateTime.format("Y-m-d", newDate)) {
            throw new _Exception.Exception(_ExceptionCode.ExceptionCode.ACCOUNT_INVALID_DATE);
          }

          this.birthdate = this.birthdate;
          break;

        case "gender":
          if ([null, "M", "F", "N", "A", "PNR"].indexOf(this.gender) < 0) {
            throw new _Exception.Exception(_ExceptionCode.ExceptionCode.ACCOUNT_INVALID_GENDER);
          }

        case "cpf":
          if (this.cpf != null && !_CPF.default.validate(this.cpf)) {
            throw new _Exception.Exception(_ExceptionCode.ExceptionCode.ACCOUNT_INVALID_CPF);
          }

      }
    });
  }

  toJSON() {
    let user = {};
    let fields = ["id", "type", "username", "email", "lgpd", "fb_id", "google_id", "name", "phone", "birthdate", "gender", "cpf", "group"];

    if (this.full_json) {
      fields = Object.keys(new User({}, true));
      fields.splice(fields.indexOf("full_json"), 1);
    }

    fields.forEach(key => {
      user[key] = this[key];
    });
    return user;
  }

}

exports.default = User;